"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bracca": {
    "77d2706b": [{
      "hkey": "736bbca7",
      "slug": "truchel-bruga",
      "name": "Truchel-Bruga",
      "primary": true,
      "skipSearch": false
    }],
    "bruga": [{
      "hkey": "736bbca7",
      "slug": "truchel-bruga",
      "name": "Truchel-Bruga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bracca"
    }],
    "a318de8c": [{
      "hkey": "aa2daa36",
      "slug": "bracca",
      "name": "Bracca",
      "primary": true,
      "skipSearch": false
    }],
    "cornalta": [{
      "hkey": "aa2daa36",
      "slug": "bracca",
      "name": "Bracca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fb047699": [{
      "hkey": "736bbca7",
      "slug": "truchel-bruga",
      "name": "Truchel-Bruga",
      "primary": true,
      "skipSearch": false
    }],
    "truchel": [{
      "hkey": "736bbca7",
      "slug": "truchel-bruga",
      "name": "Truchel-Bruga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bracca"
    }]
  }
};
exports["default"] = _default;